import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowAnullModal = createSelector(
  [(store: RootState) => store.documentShow.showAnullModal],
  (data) => data
);
